export default {
  analytics: {
    pageTitle: "Dashboard",
    subtitle: "Analytics of the events affecting your company",
    loading: "Loading analytics…",
    loadError: "Could not load analytics.",
    kpiMonth: "Events this month",
    kpiMonthSub: "last 30 days",
    kpiPortfolio: "In your portfolio",
    kpiCompetitor: "In your competitors",
    kpiTotal: "All-time total",
    kpiTotalSub: "since the start",
    empty: "No events affecting your portfolio or competitors yet. Add products and competitors to start seeing analytics.",
    trendTitle: "Event trend (30 days)",
    byTypeTitle: "By catalogue block (90 days)",
    seriesOwn: "Your portfolio",
    seriesCompetitor: "Competitors",
    barHint: "Click a bar to see its events",
    navBlock: "{block} · {side} · 90 days",
    navArea: "{area} · {side} · 90 days",
    byAreaTitle: "By therapeutic area (90 days)",
    topLabsTitle: "Most active laboratories (90 days)",
    bySourceTitle: "By source (90 days)",
    changesLabel: "events",
    noLabs: "No laboratory activity in the period.",
    noSource: "No activity by source in the period.",
    navMonth: "Events in the last month",
    navPortfolio: "Portfolio · last month",
    navCompetitor: "Competitors · last month",
    navTotal: "All relevant events",
  },
};
